import React from 'react';
import { connect } from 'react-redux';
import { FullFormModal } from 'components/Modal';
import { modalPathFor } from 'config/paths';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { createCustomRoutineDb } from 'redux/actions';
import { ModalSelectListing } from 'components/Form';

export const createCustomDbModalSuffix = '/create_custom_routine_db';

let CreateCustomDbModal = ({ createDb }) => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const path = modalPathFor(createCustomDbModalSuffix, pathname);

    return (
        <FullFormModal
            fullWidth
            path={path}
            scrollable
            exact
            icon="database"
            title={t('Set Up Custom Database')}
            formProps={() => ({
                initialValues: { importAll: true },
                submit: createDb
            })}
            footerProps={{ saveLabel: t('Create'), saveIcon: "database" }}
            render={({ modalProps, ...rest }) => {

                return (
                    <div className="pa10" style={{ maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
                        <div className="ml5 mr5 mt15">
                            <ModalSelectListing
                                name='importAll'
                                single={true}
                                col={[
                                    { text: t('Copy Strongr Fastr Database'), subtitle: t('copy sf database tip'), value: true },
                                    { text: t('Start from Scratch'), subtitle: t('start from scratch tip'), value: false }
                                ]}
                                boxClass="valign-wrapper pa10"
                                {...rest}
                            />
                        </div>
                    </div>
                );
            }}
        />
    );
}

const mapDispatchToProps = dispatch => ({
    createDb: data => dispatch(createCustomRoutineDb(data))
});

CreateCustomDbModal = connect(null, mapDispatchToProps)(CreateCustomDbModal);

export { CreateCustomDbModal };
